<!--
 * @Author: Latte
 * @Date: 2021-05-27 16:34:31
 * @LAstEditors: Latte
 * @LastEditTime: 2022-01-25 17:08:07
 * @FilePath: \Siui.Cloud.Medical.Web\src\views\cloudService\staffList\index.vue
-->
<template>
  <div class="app-container">
    <!-- 顶部栏 -->
    <div class="topbar">
      <div>
        <el-input
          v-model="searchValue"
          placeholder="工程师名字/工程师简介/用户昵称/姓/名"
          size="small"
          prefix-icon="el-icon-search"
          class="search-input"
        />
        <el-button
          type="primary"
          icon="el-icon-search"
          size="small"
          :disabled="!searchValue"
          @click.stop="search()"
        >
          搜索
        </el-button>
        <el-button
          type="info"
          icon="el-icon-refresh"
          size="small"
          @click.stop="reset()"
        >
          重置
        </el-button>
      </div>
    </div>
    <el-table
      v-loading="loading"
      :data="staffList"
      :header-cell-style="{ background: '#F5F7FA' }"
      style="width: 100%; margin-bottom: 20px"
    >
      <el-table-column label="#" prop="UserID" align="center" />
      <el-table-column label="用户昵称" prop="Nickname" align="center" />
      <el-table-column label="工程师名字" prop="CustomName" align="center" />
      <el-table-column
        label="工程师简介"
        prop="Profile"
        align="center"
        show-overflow-tooltip
      />
      <el-table-column label="是否删除" prop="IsDeleted" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.IsDeleted ? 'danger' : 'primary'">
            {{ scope.row.IsDeleted ? "已删除" : "未删除" }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="是否在线" prop="Online" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.IsDeleted ? 'primary' : 'info'">
            {{ scope.row.IsDeleted ? "在线" : "离线" }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="350">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="small"
            @click.stop="handleUpdateStaff(scope.row)"
          >
            编辑
          </el-button>
          <el-button
            type="danger"
            size="small"
            @click.stop="handleRemoveStaff(scope.row)"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <el-pagination
      background
      layout="prev, pager, next"
      :total="totalCount"
      :page-size="pageSize"
      :current-page="currentPage"
      @current-change="currentChange"
    />

    <!-- 更新工程师信息 -->
    <el-dialog :visible.sync="updateStaffDialog">
      <el-form :model="temp">
        <el-form-item label="工程师显示名称" prop="CustomName">
          <el-input
            v-model="temp.CustomName"
            placeholder="请输入工程师名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="工程师显示名称" prop="Profile">
          <el-input
            v-model="temp.Profile"
            placeholder="请输入工程师名称"
            type="textarea"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click.stop="updateStaffDialog = false">
          取 消
        </el-button>
        <el-button type="primary" size="small" @click.stop="confirmUpdate">
          保 存
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getStaffList,
  addStaff,
  updateStaff,
  deleteStaff,
} from "@/api/cloudService/staff";
export default {
  data() {
    return {
      loading: false, // 加载开关
      totalCount: 0, // 列表总数
      currentPage: 1, // 当前页码
      pageSize: 10, // 单页条数
      searchValue: "", // 搜索内容
      staffList: [], // 所有工程师列表
      updateStaffDialog: false, // 更新工程师信息对话框
      temp: {},
    };
  },
  created() {
    this.refreshCurrentList();
  },
  methods: {
    /**
     * 刷新列表
     */
    refreshCurrentList() {
      this.getAllStaffList();
    },
    /**
     * 切换 tab
     */
    handleClick() {
      this.currentPage = 1;
      this.searchValue = "";
      this.refreshCurrentList();
    },
    /**
     * 搜索
     */
    search() {
      this.currentPage = 1;
      this.refreshCurrentList();
    },
    /**
     * 重置
     */
    reset() {
      this.searchValue = "";
      this.refreshCurrentList();
    },
    /**
     * 翻页
     *
     * @param {number} currentPage 当前页码
     */
    currentChange(currentPage) {
      this.currentPage = currentPage;
      this.refreshCurrentList();
    },
    /**
     * 获取所有用户列表
     */
    getAllStaffList() {
      this.loading = true;
      const params = {
        sortName: "Online",
        sortOrder: "",
        pageNumber: this.currentPage,
        pageSize: this.pageSize,
        keyWord: this.searchValue,
        where: "",
      };
      getStaffList(params).then((res) => {
        this.staffList = res.Rows;
        this.totalCount = res.Total;
        this.utils.stopLoading(this);
      });
    },
    /**
     * 更新工程师信息
     */
    handleUpdateStaff(row) {
      this.updateStaffDialog = true;
      this.temp = {
        UserID: row.UserID,
        CustomName: row.CustomName,
        Profile: row.Profile,
      };
    },
    /**
     * 确认更新工程师信息
     */
    async confirmUpdate() {
      try {
        const res = await updateStaff(this.temp);
      } catch {
        this.$message.error("操作失败");
      }
    },
    /**
     * 删除工程师
     */
    handleRemoveStaff(row) {
      this.$confirm("此操作将永久删除该工程师, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const params = {
            ObjUserID: row.UserID,
          };
          return deleteStaff(params);
        })
        .then((res) => {
          if (!isError) {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
  },
};
</script>

<style scoped lang="scss">
</style>
